import React from 'react';
import UI from 'editor-ui-lib';
import Wix from 'Wix';
import { injectIntl } from 'react-intl';


//style
import './share.scss';

class Share extends React.Component {
 render() {
        let type = this.props.match.params.type;
        let buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.allow'});
        let details = this.props.intl.formatMessage({id: 'settings.popup.allowEditFolder'});
         
        if(type === 'editFile') {
            details = this.props.intl.formatMessage({id: 'settings.popup.allowEditFile'});
        }

        if(type === 'Folder') {
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.goToDrive'});
            details = this.props.intl.formatMessage({id: 'settings.popup.changePublicFolder'});
        } else if(type === 'File') {
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.changePublic'});
            details = this.props.intl.formatMessage({id: 'settings.popup.changePublicFile'});
        }
        if(type === 'wait') {
            details = this.props.intl.formatMessage({id: 'settings.popup.allowEditFolderDrive'});
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.gotIt'});
         }
         if(type === 'waitFile') {
            details = this.props.intl.formatMessage({id: 'settings.popup.allowEditFileDrive'});
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.gotIt'});
         }
         if(type === 'publicwait') {
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.selectAnotherItem'});
            details = this.props.intl.formatMessage({id: 'settings.popup.changeFolderePublicDrive'});

         }
         if(type === 'publicwaitFile') {
            buttonText = this.props.intl.formatMessage({id: 'settings.popup.button.selectAnotherItem'});
            details = this.props.intl.formatMessage({id: 'settings.popup.changeFilePublicDrive'});
         } 
        return (
            <div className='share-div'>
                <div className='text'>
                    {details}
                </div>
                <div className='buttons-div'>
                {type!=="wait" && type!=="waitFile" ?
                    <UI.button
                        label={this.props.intl.formatMessage({id: 'settings.popup.cancel'})}
                        className="btn-md cancel-button"
                        onClick={() => Wix.closeWindow(false)}>
                    </UI.button>
                    :
                    null}{

                    }
                    <UI.button
                        label={buttonText}
                        className="btn-md"
                        onClick={() => Wix.closeWindow(true)}>
                    </UI.button>
                </div>
            </div>
        )
    }
}

export default injectIntl(Share);



// WEBPACK FOOTER //
// ./src/settings/components/share/share.js